import React from 'react';
import { Collapse } from '@mui/material';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import ArcStack from '../arc-stack';
import ArcText from '../arc-text';
import { ArcCollapsibleSectionProps } from './types';

const ArcCollapsibleSection: React.FC<ArcCollapsibleSectionProps> = (props) => {
  const { title, defaultExpanded = true, children, sx } = props;
  const [expanded, setExpanded] = React.useState(defaultExpanded);

  return (
    <ArcStack sx={sx}>
      <ArcStack
        direction='row'
        alignItems='center'
        justifyContent='space-between'
        onClick={() => setExpanded((prev) => !prev)}
        sx={{ cursor: 'pointer', userSelect: 'none' }}>
        <ArcText.h5 fontSize={14} fontWeight={500} letterSpacing={0.4} color='common.white'>
          {title}
        </ArcText.h5>
        <KeyboardArrowDownRoundedIcon
          sx={{
            color: 'common.white',
            transition: 'transform 0.2s ease',
            transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
          }}
        />
      </ArcStack>
      <Collapse in={expanded} unmountOnExit>
        <ArcStack sx={{ pt: 2 }}>{children}</ArcStack>
      </Collapse>
    </ArcStack>
  );
};

export default ArcCollapsibleSection;
